import React from 'react';
import styles from '../cavesanarquitetura/cavesanarquitetura.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const Cavesanarquitetura: React.FC = () => {

    return (
        <div className={styles.cavesanarquitetura}>
            <div className={styles["body-thunder"]}>
                <div className={`${styles["container-thunder"]}`} >
                    <img className={styles["img-perfil"]} src={Perfil} />
                    <h1 className="pt-2">Camila Cavesan</h1>
                    <p>ARQUITETURA E INTERIORES</p>
                    <div className={styles.links}>
                        <LinkPersonalizado7
                            href="https://www.instagram.com/cavesanarquitetura?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="INSTAGRAM"
                            icon={<InstagramIcon height="32" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://wa.me/5517981450551?text=Olá, gostaria de mais informações para um orçamento de projeto..."
                            title="WHATSAPP"
                            icon={<WhatsappIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://maps.app.goo.gl/FA16Gxz3hB73uHcEA"
                            title="LOCALIZAÇÃO"
                            icon={<MapsIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cavesanarquitetura;
